import React, { Component } from 'react'
import { connect } from 'react-redux'

import PageHeader from '../components/PageHeader'
import PressCarousel from '../components/PressCarousel'
import PressPosts from '../components/PressPosts'
import PageSection from '../components/PageSection'
import Button from '../components/Button'
import Link from '../components/Link'

import { requestWpPressPostsDataSuccess } from '../../reducers/wpData'

import { getWpPosts } from '../../utils/wordpress'

import { IS_NODE, IS_PROD } from '../../config/'

export const PressPage = class PressPage extends Component {
  componentWillMount () {
    if (IS_NODE || (IS_PROD && this.props.pressPosts)) {
      return
    }
    getWpPosts({ category: 'press' }).then(
      this.props.requestWpPressPostsDataSuccess
    )
  }
  render () {
    const {
      data: {
        acf: {
          headerTitle,
          headerCarousel,
          pressCta,
          pressSectionTitle,
          downloadsSectionTitle,
          pressKitLabel,
          logoKitLabel,
          logoKit
        }
      },
      pressPosts
    } = this.props
    // since we store them in object for easier access in the state,
    // convert to the expected array here
    const posts =
      pressPosts &&
      Object.keys(pressPosts)
        .map(id => pressPosts[id])
        // sort them, since Objects have no guarantee of order in JS
        .sort((a, b) => new Date(b.date) - new Date(a.date))
    return (
      <main className='main mx-auto'>
        <PageHeader extraClass='js-dark-section' title={headerTitle}>
          {headerCarousel && <PressCarousel slides={headerCarousel} />}
        </PageHeader>

        <PageSection extraClass='relative center page-section--small'>
          <section className='mx-auto maxw-large'>
            <div className='md-col-8 mx-auto px2 justify-center flex items-center'>
              <h2 className='h3 mr3 center'>Contact us</h2>
              <Link href='mailto:press@snips.ai' forceAnchorElement>
                press@snips.ai
              </Link>
            </div>
          </section>
        </PageSection>

        <PageSection extraClass='relative center bg-white'>
          {posts &&
            posts.length > 0 && (
              <section className='mx-auto maxw-large pb2 mb4'>
                <div className='md-col-8 mx-auto px2'>
                  <h2
                    className='h1 mb4 center'
                    dangerouslySetInnerHTML={{ __html: pressSectionTitle }}
                  />
                  <PressPosts posts={posts} />
                </div>
              </section>
            )}

          <section className='mx-auto maxw-large'>
            <h2
              className='h1 mb4 center'
              dangerouslySetInnerHTML={{ __html: downloadsSectionTitle }}
            />
            {pressCta &&
              pressCta[0] &&
              pressCta[0].file && (
                <div className='mb3'>
                  <Button
                    download
                    href={pressCta[0].file}
                    className='button button--primary button--wide'
                  >
                    {pressKitLabel}
                  </Button>
                </div>
              )}
            {logoKit &&
              logoKitLabel && (
                <Button
                  download
                  href={logoKit}
                  className='button button--line button--red button--wide'
                >
                  {logoKitLabel}
                </Button>
              )}
          </section>
        </PageSection>
      </main>
    )
  }
}

function mapStateToProps ({ wpData: { pressPosts } }) {
  return {
    pressPosts
  }
}

export default connect(mapStateToProps, { requestWpPressPostsDataSuccess })(
  PressPage
)



// WEBPACK FOOTER //
// ./frontend/scripts/react/pages/PressPage.js